
import HeroSection from "@/components/HeroSection";
import TrustSection from "@/components/TrustSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import BusinessSection from "@/components/BusinessSection";
import WebDevSection from "@/components/WebDevSection";
import CallToActionSection from "@/components/CallToActionSection";
import FAQSection from "@/components/FAQSection";
import ContactForm from "@/components/ContactForm";
import SEOHead from "@/components/SEOHead";
import JsonLd from "@/components/JsonLd";
import { useFavicon } from "@/hooks/useFavicon";

const Index = () => {
  useFavicon();
  
  return (
    <div className="min-h-screen">
      <SEOHead 
        pagePath="/" 
        fallbackTitle="TECNOSYNC - Desarrollo Web y Tecnología"
        fallbackDescription="Empresa especializada en desarrollo web, aplicaciones móviles y soluciones tecnológicas innovadoras"
      />
      <JsonLd type="Organization" />
      <main>
        <HeroSection />
        <TrustSection />
        <AboutSection />
        <ServicesSection />
        <BusinessSection />
        <WebDevSection />
        <CallToActionSection />
        <FAQSection />
        <ContactForm />
      </main>
    </div>
  );
};

export default Index;
